// https://github.com/vercel/next.js/issues/49454#issuecomment-1830053413
// need a client component in the nextjs to make code-splitting work, hence the extra layer here.
// if you don't, the build will still succeed, but every page will import the animations and the bundle
// sizes will ballon.
// if you change anything with how these exports/component are done, triple check the production bundle sizes.
export * from './error-404'
export * from './generic-error'
export * from './phone-permissions'
